module.exports = function(users) {
  "use strict";
  users
  .controller('userController', userController)
	userController.$inject = ["$state","$rootScope","getDataService",'refreshtokenService','postDataService','alertService','$timeout','serverError', 'offlineError'];
	
  function userController($state,$rootScope,getDataService,refreshtokenService,postDataService, alertService, $timeout,serverError, offlineError) {
    var vmu = this;
    var validation = true;
    vmu.emailRequired = false;
    vmu.firstnameRequired = false;
    vmu.lastnameRequired = false;
    vmu.passwordRequired = false;
    vmu.passwordWeakRequired = false;
    vmu.repeatpasswordRequired = false;
    vmu.matchedpassword = false;
    vmu.roleRequired = false;
    vmu.selectedRole = {value:'default'};
    vmu.selectedStatus = {value:'1'};
    vmu.passwordWeak = false;
    vmu.passwordStrong = false;
    vmu.passwordChecked = false;
    $rootScope.hasLoaded = true;
    vmu.checkPassword = function(pass) {
      if(pass) {
        vmu.checkPasswordObj = owasp.test(pass);
        if(vmu.checkPasswordObj.strong == false) {
          vmu.passwordWeak = true;
          vmu.passwordStrong = false;
          vmu.passwordChecked = false;
        } else {
          vmu.passwordStrong = true;
          vmu.passwordWeak = false;
          vmu.passwordChecked = true;
        }   
      }
    }
    var getUsersRolesFunction = function() {
      getDataService.get({param1:'users', param2: 'roles', param3:null}).$promise.then(function(data){
        vmu.roles = data.roles; 
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          return
        }
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
          function(answer) {
            if(answer==200) {
              getUsersRolesFunction();
            }
           
            // do something
          },
          function(error) {
            // report something
          },
          function(progress) {
           // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
      });
    }
    getUsersRolesFunction(); 
    var addUserFunction = function() {
      postDataService.save({
        param1:'users'
      },{
        'email': vmu.email,
        'password': vmu.password,
        'first_name': vmu.firstname,
        'last_name' : vmu.lastname,
        'role' : vmu.selectedRole.value,
        'status' : parseInt(vmu.selectedStatus.value)
      }).$promise.then(function(data){
          $rootScope.hasLoaded = true;
          alertService('success','Success ', data.message, 2000);
          $timeout(function() {
            $state.go('app.allusers', {id: null});
          }, 1000);
      }, function(error){
        if(!window.navigator.onLine) {
          offlineError()
          $rootScope.hasLoaded = true;
          alertService('danger','Opps! ', 'Please check your internet connection and try again.');
          return
        } 
        if(error.status == 401) {
          var promise = refreshtokenService.getAccessToken();
          promise.then(
          function(answer) {
            if(answer==200) { 
              addUserFunction();
            }
            // do something
          },
          function(error) {
          },
          function(progress) {
           // report progress
          });
        } else if(error.status ==502) {
          serverError()
        } else {
          alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
        }
        $rootScope.hasLoaded = true;
      });
    }
    vmu.addNewUser = function() {
      var validation = true;
      if(!vmu.email) {
        validation = false;
        vmu.emailRequired = true;
        alertService('danger','Opps! ', 'Email is required')
      } else {
        vmu.emailRequired = false;
      }
      if(!vmu.firstname) {
        validation = false;
        vmu.firstnameRequired = true;
        alertService('danger','Opps! ', 'First name is required')
      } else {
        vmu.firstnameRequired = false;
      }
      if(!vmu.lastname) {
        validation = false;
        vmu.lastnameRequired = true;
        alertService('danger','Opps! ', 'Last name is required')
      } else {
        vmu.lastnameRequired = false;
      }
      
      if(!vmu.password) {
        validation = false;
        vmu.passwordRequired = true;
        alertService('danger','Opps! ', 'Password is required')
      } else {
        vmu.passwordRequired = false;
      }
      if(!vmu.passwordChecked) {
        validation = false;
        vmu.passwordWeakRequired = true;
      } else {
        vmu.passwordWeakRequired = false;
      }
      if(!vmu.repeatedpassword) {
        validation = false;
        vmu.repeatpasswordRequired = true;
        alertService('danger','Opps! ', 'Repeated Password is required') 
      } else {
        vmu.repeatpasswordRequired = false; 
      }
      if(vmu.repeatedpassword != vmu.password) {
        validation = false;
        vmu.matchedpassword = true;
      } else {
        vmu.matchedpassword = false;
      }
      if(vmu.selectedRole.value == 'default') {
        vmu.roleRequired = true;
        validation = false;
        alertService('danger','Opps! ', 'Choose role')
      } else {
        vmu.roleRequired = false;
      }
      if(validation) {
        $rootScope.hasLoaded = false;
        addUserFunction();
      }
    }
  }	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/usersModule/newuser/js/userController.js
// module id = 636
// module chunks = 0